import styled from 'styled-components';
import {
  colorBlack200,
  colorBlack900,
  colorGrey100,
  colorPrimary,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding-top: 8px;

  @media ${mediaQueryMobileLargeMin} {
    padding-top: 0;
  }
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
  }
`;

export const Title = styled.h2`
  margin: 0;
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${colorBlack900};

  @media ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
  }
`;

export const Legend = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  flex-shrink: 0;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    justify-content: flex-end;
    gap: 24px;
    width: auto;
  }
`;

export const LegendMainGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.36px;
  color: ${colorBlack900};
`;

export const LegendDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const NbuLegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const NbuLegendLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.36px;
  color: ${colorBlack900};
`;

export const NbuToggleWrapper = styled.div`
  position: relative;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
`;

export const NbuToggle = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 16px;
  padding: 0;
  border: 0;
  border-radius: 37px;
  background: ${({ $isActive }) => ($isActive ? colorPrimary : colorGrey100)};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: ${({ $isActive }) => ($isActive ? '11px' : '2px')};
    width: 19px;
    height: 12px;
    border-radius: 37px;
    background: ${colorWhite};
    transform: translateY(-50%);
    transition: left 0.15s ease;
  }
`;

export const ChartWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 339px;

  @media ${mediaQueryMobileLargeMin} {
    height: 280px;
  }
`;

export const ChartCanvasSlot = styled.div`
  width: 100%;
  height: 100%;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 8px;
  pointer-events: none;
`;

export const LoadingText = styled.p`
  margin: 0;
  flex-shrink: 0;
  width: max-content;
  font-family: ${fontFamilyPrimary};
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  white-space: nowrap;
  color: ${colorBlack200};
`;

export const Empty = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 339px;
  font-family: ${fontFamilyPrimary};
  color: #93a1a9;

  @media ${mediaQueryMobileLargeMin} {
    height: 280px;
  }
`;
